import React from 'react'
import { APP_URL } from '../../utils/config.js'
import { ReactComponent as NormalTrapezoid } from '../../../assets/icons/normal-trapezoid.svg'
import { ReactComponent as ReverseTrapezoid } from '../../../assets/icons/reversed-trapezoid.svg'

const ZipperOrientationCards = ({ zipperOrientation, setZipperOrientation }) => {
  return (
    <div className="orientation-wrapper">
      <p>Please Choose The Orientation:</p>
      <div className="orientation-cards-wrapper">
        <div
          className={`orientation-card ${!zipperOrientation ? 'selected' : ''}`}
          onClick={setZipperOrientation(0)}
        >
          <div className="cushion-style-selector-card-checkbox">
            <img src={`${APP_URL}/wp-content/uploads/2021/10/Shape-1@2x.png`} />
          </div>
          <div className="orientation-card-content">
            <div>Back</div>
            <NormalTrapezoid className="orientation-card-image" />
            <div>Front</div>
          </div>
        </div>
        <div
          className={`orientation-card ${zipperOrientation ? 'selected' : ''}`}
          onClick={setZipperOrientation(1)}
        >
          <div className="cushion-style-selector-card-checkbox">
            <img src={`${APP_URL}/wp-content/uploads/2021/10/Shape-1@2x.png`} />
          </div>
          <div className="orientation-card-content">
            <div>Back</div>
            <ReverseTrapezoid className="orientation-card-image" />
            <div>Front</div>
          </div>
        </div>
      </div>
    </div>
  )

  // return open ? (
  //   <div className="modal-overlay">
  //     <div className="modal">
  //       <div className="content-container">
  //         <p className="modal-title">Please Choose The Orientation:</p>
  //         <div className="zipper-orientation-options-container">
  //           <img
  //             className={`ziper-orientation-option ${!shouldSelectZipperOrientation && !zipperOrientation ? 'selected' : ''}`}
  //             alt="zipper-normal"
  //             src={`${APP_URL}/wp-content/uploads/2023/09/trapezoid_zipper_reversed.png`}
  //             onClick={setZipperOrientation(0)}
  //           />
  //           <img
  //             className={`ziper-orientation-option ${!shouldSelectZipperOrientation && zipperOrientation ? 'selected' : ''}`}
  //             alt="zipper-normal"
  //             src={`${APP_URL}/wp-content/uploads/2023/09/trapezoid_zipper_normal.png`}
  //             onClick={setZipperOrientation(1)}
  //           />
  //         </div>
  //         <div className="footer-container">
  //           {hasCloseButton && (
  //             <button className="modal-button close" type="button" onClick={onClose}>
  //               Close
  //             </button>
  //           )}
  //         </div>
  //       </div>
  //     </div>
  //   </div>
  // ) : null
}

export default ZipperOrientationCards
